(() => {
  const config = document.querySelector('script[data-lcq-drawer-loader]');

  if (
    !config ||
    document.getElementById('lcq-desktop-drawer') ||
    /\/(?:cart|checkouts?)(?:\/|$)/.test(location.pathname)
  ) {
    return;
  }

  const desktop = matchMedia('(min-width: 750px)');
  const pageURL = new URL(config.dataset.page, location.href);

  if (pageURL.origin !== location.origin) return;

  const fr = config.dataset.lang === 'fr';
  const label = fr ? 'Questionnaire peau' : 'Skin questionnaire';
  const dialog = document.createElement('dialog');

  if (typeof dialog.showModal !== 'function') return;

  dialog.id = 'lcq-desktop-drawer';
  dialog.setAttribute('aria-labelledby', 'lcq-drawer-title');

  const head = document.createElement('header');
  head.className = 'lcq-drawer-head';

  const title = document.createElement('span');
  title.id = 'lcq-drawer-title';
  title.textContent = 'Loshen & Crem · ' + label;

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.setAttribute(
    'aria-label',
    fr ? 'Fermer le questionnaire' : 'Close questionnaire'
  );

  const closeText = document.createElement('span');
  closeText.textContent = fr ? 'Fermer' : 'Close';

  const cross = document.createElement('span');
  cross.textContent = '×';
  cross.setAttribute('aria-hidden', 'true');

  closeButton.append(closeText, cross);
  head.append(title, closeButton);

  const content = document.createElement('div');
  content.className = 'lcq-drawer-content';

  dialog.append(head, content);
  document.body.append(dialog);

  let sourceURL = pageURL.href;
  let opener;
  let loaded = false;
  let pending;
  let oldOverflow = '';
  let locked = false;

  const close = () => {
    if (dialog.open) dialog.close();
  };

  dialog.addEventListener('close', () => {
    if (locked && document.body.style.overflow === 'hidden') {
      document.body.style.overflow = oldOverflow;
    }

    locked = false;

    if (opener?.isConnected) {
      opener.focus({preventScroll: true});
    }
  });

  closeButton.addEventListener('click', close);

  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;

    const box = dialog.getBoundingClientRect();

    if (
      event.clientX < box.left ||
      event.clientX > box.right ||
      event.clientY < box.top ||
      event.clientY > box.bottom
    ) {
      close();
    }
  });

  window.addEventListener('pagehide', close);

  // An open questionnaire stays in place when the viewport changes.
  // Opening it on mobile still follows the normal page link.

  const loadScript = src => new Promise((resolve, reject) => {
    if (customElements.get('loshen-skin-quiz')) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;

    script.onload = () => {
      if (customElements.get('loshen-skin-quiz')) {
        resolve();
      } else {
        reject(new Error('quiz'));
      }
    };

    script.onerror = () => {
      script.remove();
      reject(new Error('script'));
    };

    document.head.append(script);
  });

  const load = async () => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);

    const loading = document.createElement('p');
    loading.className = 'lcq-drawer-loading';
    loading.setAttribute('role', 'status');
    loading.textContent = fr
      ? 'Votre questionnaire se prépare…'
      : 'Preparing your questionnaire…';

    content.replaceChildren(loading);
    content.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(sourceURL, {
        signal: controller.signal,
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error('page');

      const doc = new DOMParser().parseFromString(
        await response.text(),
        'text/html'
      );

      const quiz = doc.querySelector('loshen-skin-quiz');
      const style = doc.querySelector('style[data-lcq-page-style]');
      const script = doc.querySelector('script[data-lcq-page-script][src]');

      if (!quiz || !style || !script) throw new Error('template');

      const asset = new URL(script.getAttribute('src'), sourceURL);

      await loadScript(asset.href);

      quiz.dataset.presentation = 'drawer';
      content.replaceChildren(
        style.cloneNode(true),
        document.importNode(quiz, true)
      );

      loaded = true;

      if (dialog.open) {
        content.querySelector('[data-action="start"]')?.focus({
          preventScroll: true
        });
      }
    } catch (error) {
      const box = document.createElement('div');
      box.className = 'lcq-drawer-error';

      const message = document.createElement('p');
      message.textContent = fr
        ? 'Ouvrons votre questionnaire sur sa page.'
        : 'Let’s open your questionnaire on its page.';

      const link = document.createElement('a');
      link.href = sourceURL;
      link.dataset.lcqFullPage = '';
      link.textContent = fr
        ? 'Continuer vers le questionnaire '
        : 'Continue to the questionnaire ';

      box.append(message, link);
      content.replaceChildren(box);
    } finally {
      clearTimeout(timer);
      content.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', event => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      !desktop.matches
    ) {
      return;
    }

    const link = event.target.closest('a[href]');

    if (
      !link ||
      link.hasAttribute('download') ||
      link.dataset.lcqFullPage !== undefined ||
      (link.target && link.target !== '_self')
    ) {
      return;
    }

    const url = new URL(link.href, location.href);

    if (
      url.origin !== location.origin ||
      url.pathname.replace(/\/$/, '') !== pageURL.pathname.replace(/\/$/, '')
    ) {
      return;
    }

    event.preventDefault();

    if (config.dataset.view) url.searchParams.set('view', config.dataset.view);
    sourceURL = url.href;
    opener = link;

    if (!dialog.open) {
      oldOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      locked = true;
    }

    if (!loaded && !pending) {
      pending = load().finally(() => {
        pending = null;
      });
    }
  }, true);
})();
